import { useQueryClient } from '@tanstack/react-query';
import LangEnum from '../../../lang/LangEnum';
import { getOrderQueryKey } from '../../../services/modules/order/order.keys';
import { getFindOrderConditionsKey } from '../../../services/modules/orderCondition/orderCondition.keys';
import useOrderProductsReloadStore from '../../../stores/OrderProductsReload/orderProductsReload.store';
import snackbarStore from '../../../stores/Snackbar.store';
import { useRachelEventListener } from '../../rachel/effects/useRachelEventListener';
import { useTranslation } from '../../translation/TranslationContext';
import { validateOrderProductsQuery } from '../contexts/order.utils';
import useCalculateSummary from '../hooks/useCalculateSummary';
import { getOrderRachelScope } from './orderRachelScope';

export const useOrderRachelSync = (orderId: string, teamId?: string): void => {
  const queryClient = useQueryClient();
  const { calculateSummary } = useCalculateSummary();
  const { translate } = useTranslation();

  const orderQueryKey = [teamId, ...getOrderQueryKey({ orderId })];

  const refetchOrderAndNotifySaved = async () => {
    await queryClient.refetchQueries({ queryKey: orderQueryKey }, { throwOnError: true });
    const orderState = queryClient.getQueryState(orderQueryKey);

    if (orderState?.status === 'success' && orderState.fetchStatus === 'idle') {
      snackbarStore.handleMessage({ type: 'success', message: translate(LangEnum.AUTOSAVE_SAVED) });
    }
  };

  useRachelEventListener({
    ...getOrderRachelScope(orderId),
    onChange: () => {
      refetchOrderAndNotifySaved().catch(() => undefined);
      queryClient.refetchQueries({
        queryKey: [teamId, ...getFindOrderConditionsKey({ orderId })],
      });
      calculateSummary();
      queryClient.refetchQueries(validateOrderProductsQuery(orderId, teamId));
      useOrderProductsReloadStore.getState().requestReload(orderId, { isFromRachel: true });
    },
  });
};
